angular.module("core").factory("FormError", function() {
    return {
        focus: function(form_name, offset) {
            var form = document.getElementsByName(form_name);
            if (form.length) {
                var firstInvalid = form[0].querySelector(".ng-invalid:not([type=\"file\"])");
                if (firstInvalid) {
                    if (offset) {
                        $(window).scrollTop($(firstInvalid).offset().top + offset);
                    }
                    firstInvalid.focus();
                }
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/form-error/form-error.factory.js
// module id = 461
// module chunks = 0